<template>
    <div class="indexCont">
        <div class="mainCont"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
             <el-button class="gt_back" icon="el-icon-arrow-left" size="small" @click="goBack()">返回</el-button>
            <div class="head">
                <div class="title">{{allData.paperName}}</div>
                <div class="time">
                    考试时间：<span>{{allData.limitTime}}分钟</span>
                    <span class="remainTime">{{remainTime}}</span>
                </div>
            </div>
            <div v-if="dataLoaded">
                <div class="examItem"  
                    v-for="(item, index) in questionSingleList" 
                    :key="'l1' + index">
                    <div class="eTitle">
                        <span>{{questionSingleNoList[index]}}、{{item.questionName}} 【{{item.typeName}}】</span>
                    </div>
                    <el-radio-group 
                        v-model="answerTypeSingle[index]"  
                        v-for="(subitem, subindex) in item.questionContent" 
                        :key="'l2' + subindex">
                        <el-radio 
                            :label="subitem.name"
                            v-show="subitem.detail || subitem.url ? true : false">
                            {{subitem.name}}、{{subitem.detail}}
                        </el-radio>
                        <!-- 有url -->
                        <template v-if="subitem.url">
                            <img class="comItem_img" :src="$config.baseApi + subitem.url" alt="">
                        </template>
                    </el-radio-group>
                    <div class="comBtn" @click="collectBtn(item.questionId)">收藏试题</div>
                </div>  
                <div class="examItem" 
                    v-for="(item, index) in questionMultiList" 
                    :key="'l3' + index">
                    <div class="eTitle">
                        <span>{{questionMultiNoList[index]}}、{{item.questionName}}  【{{item.typeName}}】</span>
                    </div>
                    <el-checkbox-group 
                        v-model="answerTypeMulti[index]"
                        v-for="(subitem2,index2) in item.questionContent" 
                        :key="index2">
                        <el-checkbox 
                            :label="subitem2.name"
                            v-show="subitem2.detail || subitem2.url ? true : false">
                            {{subitem2.name}}、{{subitem2.detail}}
                        </el-checkbox>
                         <!-- 有url -->
                        <template v-if="subitem2.url">
                            <img class="comItem_img" :src="$config.baseApi + subitem2.url" alt="">
                        </template>
                    </el-checkbox-group>
                    <div class="comBtn"  @click="collectBtn(item.questionId)">收藏试题</div>
                </div>
                <div class="examItem" 
                    v-for="(item, index) in questionFillList" 
                    :key="'l5' + index">
                    <div class="eTitle">
                        <span>{{questionFillNoList[index]}}、{{item.questionName}}  【{{item.typeName}}】</span>
                    </div>
                    <el-input
                            class="completion"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入答案"
                            v-model="answerTypeFill[index]">
                    </el-input>
                    <div class="comBtn" @click="collectBtn(item.questionId)">收藏试题</div>
                </div>
            </div>
            <div class="comBtn submit" @click="submitPaper">提交试卷</div>
            <!-- 填写信息弹窗 -->
            <el-dialog :title="infoTitle" 
                       :visible.sync="dialogFormVisible" 
                       center
                       :close-on-press-escape="false" 
                       :width="dialogWidth"
                       :show-close="showClose">
                <el-form :model="form" ref="form">
                    <el-form-item label="姓名" prop="name" :label-width="formLabelWidth" :rules="{required: true, message:'姓名不能为空'}">
                        <el-input v-model="form.name" type="name" autocomplete="off" placeholder=" 请输入考生姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="部门" prop="department" :label-width="formLabelWidth" :rules="{required: true, message:'部门不能为空'}">
                        <el-input v-model="form.department" type="department" autocomplete="off" placeholder=" 请输入部门"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="mobile" :label-width="formLabelWidth" :rules="{required: true, message:'联系方式不能为空'}">
                        <el-input v-model="form.mobile" type="mobile" autocomplete="off" placeholder=" 请输入联系方式"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false" :disabled="isDisabled">取 消</el-button>
                    <el-button type="primary" @click="makeSure('form')">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 收藏弹窗 -->
            <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                :width="dialogWidth"
                center>
                <span>是否确定收藏试题</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="collectItem()">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 无需填写信息时提交试卷 -->
            <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible2"
                :width="dialogWidth"
                center>
                <span>是否确定提交试卷</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="makeSure2()">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 证书 -->
            <el-dialog
                :visible.sync="DialogVisibleCert"
                :width="certDialogWidth"
                :close-on-press-escape="false"
                :before-close="handleClose"
                center>
                <div class="certPic">
                    <img src="../../../assets/images/common/certPic.jpg" alt="" v-if="isShowCetrtPic">
                    <img :src="$config.baseApi + certPic" alt="" v-else>
                    <!-- <div class="cert_txt">
                        <div class="username">{{username}}</div>
                        <div class="certCode">编号No：{{certCode}}</div>
                        <div class="time">日期Date：{{certTime}}</div>
                    </div> -->
                </div>
            </el-dialog>
             <!-- 判断填写信息弹窗 -->
            <el-dialog
                title="用户信息"
                :visible.sync="personDialogVisible"
                :width="dialogWidth"
                :show-close="false"
                :close-on-press-escape="false" 
                :close-on-click-modal="false"
                class="commonDialog">
                <span class="personMess">
                    <div>用户没有录入信息，快去个人中心填写信息</div>
                    <div @click="goPerson()">去个人中心</div>
                </span>
            </el-dialog>
             <!-- 填写用户信息 -->
            <el-dialog title="用户信息" 
                        :visible.sync="dialogFormVisible2" 
                        center
                        :close-on-press-escape="false" 
                        :close-on-click-modal="false"
                        :show-close="false"
                        :width="dialogWidth"
                        class="commonDialog">
                <el-form :model="form2" ref="form2">
                    <el-form-item label="姓名" prop="name" :label-width="formLabelWidth" :rules="{required: true, message:'姓名不能为空'}">
                        <el-input v-model="form2.name" type="name" autocomplete="off" placeholder=" 请输入考生姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="公司" prop="company" :label-width="formLabelWidth" :rules="{required: true, message:'公司不能为空'}">
                        <el-input v-model="form2.company" type="company" autocomplete="off" placeholder=" 请输入公司"></el-input>
                    </el-form-item>
                    <el-form-item label="部门" prop="department" :label-width="formLabelWidth" :rules="{required: true, message:'部门不能为空'}">
                        <el-input v-model="form2.department" type="department" autocomplete="off" placeholder=" 请输入部门"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="mobile" :label-width="formLabelWidth" :rules="{required: true, message:'联系方式不能为空'}">
                        <el-input v-model="form2.mobile" type="mobile" autocomplete="off" placeholder=" 请输入联系方式"></el-input>
                    </el-form-item>
                </el-form>
                <div class="personTip">提示：请如实填写以上信息，如有不实信息系统账号将自动清除</div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="goBack()" :disabled="false">取 消</el-button>
                    <el-button type="primary" @click="submitPerson('form2')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="考试" :url="redirectUrl"></MobileComNav>
        </div>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    import getQuery from "../../../assets/js/libs/getQuery.js";
    import { Message } from "element-ui";
    let oMessage = Message;
    export default {
        data(){
            return{
                dialogFormVisible: false,
                centerDialogVisible: false,
                centerDialogVisible2:false,
                DialogVisibleCert:false,
                isShowCetrtPic:true,
                loading: true,
                form: {
                    name: '',
                    department: '',
                    mobile:''
                },
                infoTitle:"考生信息",
                isDisabled:false,
                showClose:true,
                formLabelWidth: '65px',
                dialogWidth:"30%",
                certDialogWidth:"5rem",
                remainTime:"", // 剩余时间
                timer:"",//计时器名字
                count:0, //计数
                allData:"",
                questionItemVoList:[],
                questionIdType1:[],
                questionIdType2:[],
                questionIdType3:[],
                answerTypeSingle:[], //单选结果
                answerTypeMulti:[],  //多选结果
                answerTypeFill:[],   //填空结果
                atmStr:[],//多选结果的字符串格式
                dataLoaded:false,
                questionSingleList: [], //单选题
                questionMultiList: [],  //多选题
                questionFillList: [],   //填空题
                questionSingleNoList: [], //单选题目编号
                questionMultiNoList: [],  //多选题目编号
                questionFillNoList: [],    //填空题目编号
                answerSingle:[],
                answerMulti:[],
                answerFill:[],
                answerList:[],
                paperId:"",
                companyId:"",
                // paperHistoryId:'',
                questionId:"",
                operateType:1, //1代表收藏
                username:"",
                certCode:"",
                certTime:"",
                certPic:"",
                redirectUrl:"./test",
                linkFlag:false, //判断是不是外部链接，是否需要强刷换logo
                curPage:1,
                personDialogVisible:false,
                dialogFormVisible2:false,
                form2: {
                    name: '',
                    company:'',
                    department: '',
                    mobile:''
                },
                getPaperHistoryId:""
            }
        },
        components: {
            MobileComNav
        },
        mounted(){
            document.title=this.$route.meta.title;
        },
        methods: {
            goBack(){
                if(window.location.href.indexOf('train') > -1){
                    this.$router.go(-1)
                }else{
                    this.$router.push(this.redirectUrl +'?curPage=' + this.curPage)
                }
                
            },
            collectBtn(questionId){
                this.centerDialogVisible = true;
                this.questionId = questionId
            },
            // 收藏
            collectItem(){
                this.centerDialogVisible = false;
                let url = this.$config.baseApi + "/examination/favorite/operate";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        questionId:this.questionId,
                        operateType:this.operateType
                    })
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message:res.msg,
                            type:"success"
                        })
                    }else{
                        this.$message({
                            message:res.msg,
                            type:"error"
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 需要填写信息
            makeSure(formName) {
                clearInterval(this.timer);
                let duration = Math.round(this.count / 60)
                if(duration == 0){
                    duration = 1
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.createAnswer();
                        this.commitPaper(duration)
                    } else {
                        return false;
                    }
                });
            },
            // 无需填写信息
            makeSure2(){
                this.createAnswer()
                clearInterval(this.timer);
                let duration = Math.round(this.count / 60)
                if(duration == 0){
                    duration = 1
                }
                this.centerDialogVisible2 = false;
                this.commitPaper(duration)
            },
            // 试卷内容
            getPaper(paperId){
                let url = this.$config.baseApi + "/examination/paper/create"
                this.$ajax({
                    url:url,
                    data:{'companyId':this.companyId, 'paperId':this.paperId},
                    method:'post',
                }).then(res=>{
                    this.loading = false;
                    if(res.code == 1){
                        let pushStatus = res.data.pushStatus; //2未发布不可参与考试
                        if(pushStatus === 2){
                            this.$message({
                                message:"试卷未发布，无法考试",
                                type:"error"
                            })
                            setTimeout(()=>{
                                this.goBack()
                            },2000)
                        }else{
                            this.allData = res.data;
                            this.questionItemVoList = res.data.questionItemVoList;
                            // 将id放入不同类型的数组中
                            let questionList = res.data.questionItemVoList;
                            for(let i in questionList){
                                const type = questionList[i].type;
                                if(type == 1){
                                    this.questionIdType1.push(questionList[i].questionId)
                                    this.questionSingleList.push(questionList[i])
                                } else if(type === 2){
                                    this.questionIdType2.push(questionList[i].questionId)
                                    this.answerTypeMulti.push([])
                                    this.questionMultiList.push(questionList[i])
                                } else if (type === 3) {
                                    this.questionIdType3.push(questionList[i].questionId)
                                    this.questionFillList.push(questionList[i])
                                }
                            }
                            let no = 1; //试题编号
                            for (let i in this.questionSingleList) {
                                this.questionSingleNoList.push(no ++)
                            }
                            for (let i in this.questionMultiList) {
                                this.questionMultiNoList.push(no ++)
                            }
                            for (let i in this.questionFillList) {
                                this.questionFillNoList.push(no ++)
                            }

                            this.dataLoaded = true;
                            this.$message({
                                message:"开始考试",
                                type:'success'
                            })
                        }
                    }else{
                        oMessage({
                            message :res.msg,
                            type:'error'
                        })
                        setTimeout(() => {
                            this.$router.push({path:'/test',query:{curPage:this.$route.query.curPage}})
                        }, 1500);
                    }
                }).catch(err =>{
                    console.log(err)
                    let link = window.location.href;
                    if(link.indexOf('code') == -1){
                        localStorage['link'] = window.location.href
                    }
                })
            },
            // 提交试卷
            commitPaper(duration){
                let url = this.$config.baseApi + "/examination/paper/commit"
                this.$ajax({
                    url:url,
                    data:JSON.stringify({
                        'paperId':this.paperId,
                        // 'paperHistoryId':this.paperHistoryId, //历史列表传递
                        'answerList':this.answerList,
                        'duration':duration,
                        'username':this.form.name,
                        'departmentName':this.form.department,
                        'mobile':this.form.mobile
                    }),
                    method:'post',
                }).then(res=>{
                    console.log(res)
                    if(res.code == 1){
                        oMessage({
                            message:"提交试卷成功",
                            type:'success'
                        })
                        this.getPaperHistoryId = res.data.paperHistoryId
                        let certStatus = res.data.certStatus; //是否有证书
                        if(certStatus){
                            this.DialogVisibleCert = true;
                            this.certCode = res.data.staffUserPaperCertVo.certCode;
                            this.certTime = res.data.staffUserPaperCertVo.createTime.slice(0,10);
                            this.username = res.data.staffUserPaperCertVo.username;
                            let certPic = res.data.staffUserPaperCertVo.certPic;
                            if(certPic){
                                this.certPic = certPic;
                                this.isShowCetrtPic = false
                            }
                        }else{
                            setTimeout(()=>{
                                // this.goBack()
                                this.$router.push('./testDetail?paperHistoryId=' + this.getPaperHistoryId + '&curPage=' + 1);
                            },1000)
                        }
                    }else{
                        oMessage({
                            message:res.msg,
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            handleClose(){
                // this.goBack()
                this.$router.push('./testDetail?paperHistoryId=' + this.getPaperHistoryId + '&curPage=' + 1);
            },
            // 考试计时
            useTime(){
                var nowTime = new Date();
                this.timer = setInterval (()=>{
                    var d = new Date();
                    var futureDate = nowTime.getTime() + this.allData.limitTime * 60 * 1000;
                    var ms =futureDate  - d.getTime();
                    var hours = parseInt((ms % (1000 * 60 * 60 *24)) / (1000 * 60 * 60));
                    var minutes = parseInt(((ms % (1000 * 60 * 60 *24)) % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = parseInt((((ms % (1000 * 60 * 60 *24)) % (1000 * 60 * 60)) % (1000 * 60)) / 1000);
                    this.remainTime ="剩余时间：" + hours + "小时" + minutes + "分" + seconds+ "秒";
                    this.count += 1;
                    if(ms <= 0){
                        this.remainTime = "考试结束"
                        clearInterval(this.timer);
                        let userInfoStatus = this.allData.userInfoStatus
                        if(userInfoStatus === 1){
                            this.infoTitle = "考试时间到，请填写信息"
                            this.dialogFormVisible = true;
                            this.isDisabled = true;
                            this.showClose = false;
                        }else{
                            this.$message({
                                message:"考试时间到，试卷已提交",
                                type:'warning'
                            })
                            this.createAnswer()
                            this.commitPaper(this.allData.limitTime)
                        }
                    }
                },1000);
            },
            submitPaper() {
                let userInfoStatus = this.allData.userInfoStatus
                // 为1需要填写部门，姓名。。
                if(userInfoStatus === 1){
                    this.dialogFormVisible = true;
                }else{
                    this.centerDialogVisible2 = true
                }
                // console.log("单选结果:", this.answerTypeSingle,this.questionIdType1)
                // console.log("多选结果:", this.answerTypeMulti,this.questionIdType2)
                // console.log("填空结果:", this.answerTypeFill,this.questionIdType3)
            },
            createAnswer(){
                //将多选里的数组转化成字符串
                for(var r in this.answerTypeMulti){
                    let ss= this.answerTypeMulti[r].join("");
                    this.atmStr.push(ss)
                }
                // 将答案合并成接口想要格式
                for(var k in this.questionIdType1 ){
                    this.answerSingle.push({questionId : this.questionIdType1[k]})
                }
                for(var j in this.answerSingle){
                    let an = this.answerTypeSingle[j] ? this.answerTypeSingle[j] : ""
                    this.answerSingle[j].answer = an
                }
                for(var l in this.questionIdType2 ){
                    this.answerMulti.push({questionId : this.questionIdType2[l]})
                }
                for(var m in this.answerMulti){
                    let an = this.atmStr[m] ? this.atmStr[m] : ""
                    this.answerMulti[m].answer = an
                }
                for(var n in this.questionIdType3 ){
                    this.answerFill.push({questionId : this.questionIdType3[n]})
                }
                for(var p in this.answerFill){
                    let an = this.answerTypeFill[p] ? this.answerTypeFill[p] : ""
                    this.answerFill[p].answer = an
                }
                // 将答案合并到一起
                for(let aa in this.answerSingle){
                    this.answerList.push(this.answerSingle[aa])
                }
                for(let bb in this.answerMulti){
                    this.answerList.push(this.answerMulti[bb])
                }
                for(let cc in this.answerFill){
                    this.answerList.push(this.answerFill[cc])
                }
            },
            // 公司logo
            getLogo(){
                this.$ajax({
                    url:this.$config.baseApi + "/account/company/wx",
                    method:'post'
                }).then(res=>{
                    if(res.code == 1){
                        let companyName = res.data.companyName;
                        let logo = res.data.logo;
                        if(companyName){
                            localStorage['companyName']=companyName;
                        }
                        if(logo){
                            localStorage['logo']=logo;
                        }else{
                            localStorage['logo']="";
                        }
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // // 判断是否录入用户信息
            // checkName(){
            //      this.$ajax({
            //         url:this.$config.baseApi + "/account/wx/check/name",
            //         method:'get'
            //     }).then(res=>{
            //         if(res.code == 2){
            //             //版本2取消去个人中心
            //             this.personDialogVisible = false;
            //         }else if(res.code == 1){
            //             this.getPaper()
            //         }
            //     }).catch(err =>{
            //         console.log(err)
            //     })
            // },
             // 需要填写信息
            submitPerson(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogFormVisible2 = false;
                        this.submitMessage
                        // this.getPaper()
                        this.submitMessage()
                    } else {
                        return false;
                    }
                });
            },
            goPerson(){
                this.dialogFormVisible2 = true;
                this.personDialogVisible = false;
            },
            submitMessage(){
                 this.$ajax({
                    url:this.$config.baseApi + "/account/wx/change/info",
                    method:'post',
                    data:JSON.stringify({
                        'realName':this.form2.name,
                        'mobile':this.form2.department,
                        'companyName':this.form2.company,
                        'departmentName':this.form2.department,
                    })
                }).then(res=>{
                    console.log(res)
                    if(res.code == 1){
                        this.getPaper()
                        this.$message({
                            message:res.msg,
                            type:"success"
                        })
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
        },
        created(){
            if(this.$IsPc()){
                this.dialogWidth = "80%";
                this.certDialogWidth = "6rem"
            };
            this.useTime();
            let link = window.location.href;
            if(link.indexOf('paperId') > -1 && link.indexOf('companyId') > -1){
                this.paperId = getQuery('paperId');
                this.companyId = getQuery('companyId');
                if(link.indexOf('curPage') > -1){
                    this.curPage = getQuery('curPage')
                }
                // this.paperHistoryId = getQuery('paperHistoryId');
                if(link.indexOf('url') > -1){
                    this.redirectUrl = getQuery('url')
                }else{
                    this.linkFlag = true
                }
                this.getPaper();
                this.getLogo();
            }else{
                this.$message({
                    message:"缺少参数paperId或companyId",
                    type:"error"
                })
            }
        },
        destroyed(){
            clearInterval(this.timer);
            if(this.linkFlag){
                window.location.reload()
            }     
        }
        
    }
    
</script>

<style scoped>
    .mainCont{
        background: #fff;
        padding:0.17rem 0.3rem;
        position: relative;
        min-height: 4rem;
    }
    .head{
        border-bottom: 2px dashed #ccc;
        text-align: center;
        font-weight: 500;
        font-size: 0.2rem;
    }
    .head .time{
        font-size: 0.16rem;
        margin:0.1rem 0 0.17rem;
    }
    .gt_back{
        position: absolute;
        top:0.17rem;
    }
    /* 题目样式 */
    .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
        display: block;
        margin:0.1rem 0;
    }
    .examItem{
        font-size: 0.16rem;
        margin-bottom: 0.2rem
    }
    .examItem .eTitle{
        margin-top:0.15rem;
    }
    .comBtn.submit{
        background-color: rgba(0, 186, 173, 1);
        margin:0 auto 0.2rem;
        padding:0.09rem 0.4rem;
    }
    .mobileTest{
        display: none;
        margin-top: 1.2rem;
    }
    .remainTime{
        margin-left:0.2rem;
    }
    .personMess{
    font-size:0.2rem;
    }
    .personMess div:nth-child(1){
        text-align: center;
    }
    .personMess div:nth-child(2){
        text-align: right;
        margin-top:0.2rem;
        color:#417ccb;
        cursor: pointer;
    }
     .personTip{
        color: #417ccb;
        text-align: left;
        font-size:0.16rem;
        padding-left:0.15rem;
    }
    /* 移动端 */
    @media screen and (max-width: 768px) {
        .mainCont {
            margin-top:0.9rem;
            box-sizing: border-box;
            background:transparent;
            padding:0;
            min-height: 8rem;
        }
        .examItem{ 
            box-sizing: border-box;
            background: #fff;
            width:90%;
            margin:0 auto;
            padding:0.2rem;
            margin-bottom: 0.4rem;
            font-size: 0.32rem;
        }
        .head{
            background: #fff;
            border-bottom:0; 
            font-size: 0.4rem;
            padding-top:0.2rem;
        }
        .head .time{
            font-size: 0.32rem;
            padding-bottom:0.2rem;
        }
        .gt_back{
            display: none;
        }
        .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
            margin:0.2rem 0;
        }
        .mobileTest {
            display: block;
        }
         .comBtn.submit{
            padding:0.18rem 0.8rem;
        }
        .personMess{
            font-size:0.34rem;
        }
        .personTip{
            font-size:0.24rem;
            padding-left:0.2rem;
        }
    }
</style>
